import React from 'react';
import { Loader2, ShieldOff } from 'lucide-react';
import { usePermissions } from '../../context/PermissionsContext';
import { routePermissionFor } from '../../lib/permissionGates';
import { permissionsCopy } from '../../copy/permissions';
import { EmptyState } from '@/components/ui/empty-state';

// What a page shows when an admin has set this user's permission for it to
// No: one plain card, no upgrade offer (it isn't the plan), and never the
// page half-loaded with refusals. Nav already hides these pages.

export function NoAccessCard({ message, className }: { message: string; className?: string }) {
  return (
    <EmptyState
      icon={ShieldOff}
      title={message}
      body={permissionsCopy.howToChange}
      className={className ?? 'mx-auto mt-6 max-w-xl'}
    />
  );
}

/**
 * Renders the page, or the no-access card when the user's permissions are
 * known to leave it out. Waits for the first answer rather than letting the
 * page start requests that would be refused; unknown (the request failed)
 * renders the page, and the server still refuses what isn't allowed.
 */
export function RoutePermissionGuard({ pathname, children }: { pathname: string; children: React.ReactNode }) {
  const { status, can } = usePermissions();
  const needs = routePermissionFor(pathname);
  if (!needs) return <>{children}</>;
  if (status === 'loading') {
    return (
      <div className="flex min-h-[200px] items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }
  if (!can(needs.permission)) return <NoAccessCard message={needs.noAccess} />;
  return <>{children}</>;
}
